// src/api.js
import axios from 'axios';

const api = axios.create({
    // Jab aap Render par ho to ye URL chalega
    baseURL: 'https://payroll-mang.onrender.com/api/payroll',
    headers: {
        'Content-Type': 'application/json'
    }
});

// Agar aapne JWT use kiya hai to ye interceptor token automatically bhej dega
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;